import { css } from '@emotion/react';
import { colors } from '../../global';

export const ButtonOrange = css`
    color: ${colors.white};
    background: ${colors.mandySandybrownGradient};
`;
